// src/components/landing/WhyChooseZamziSection.tsx
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { BrainCircuit, TrendingUp } from "lucide-react";
import Image from "next/image";

const reasons = [
  {
    icon: <Image src="https://firebasestorage.googleapis.com/v0/b/zamzi-connect.firebasestorage.app/o/GEOTRANSP.svg?alt=media&token=47696a06-a461-4196-a782-3da8f60c935c" alt="Location pin icon representing GEO-optimized business profiles for South Africa" width={40} height={40} className="mb-4" loading="lazy" />,
    title: "GEO-Optimized Profiles",
    description: "Be the top result in your neighborhood. Our technology puts you on the map, literally, so local customers and employers find you before the competition.",
  },
  {
    icon: <Image src="https://firebasestorage.googleapis.com/v0/b/zamzi-connect.firebasestorage.app/o/SEOTRANSP.svg?alt=media&token=4d8fac2c-b158-4bc7-80e6-52d7026d54fa" alt="AI brain icon representing AI-powered SEO for South African business profiles" width={40} height={40} className="mb-4" loading="lazy" />,
    title: "AI-Powered SEO",
    description: "Our AI analyzes your profile and automatically generates the perfect keywords, ensuring you rank higher on Google and within Zamzi Connect's search.",
  },
  {
    icon: <Image src="https://firebasestorage.googleapis.com/v0/b/zamzi-connect.firebasestorage.app/o/VISTRANSP.svg?alt=media&token=2bf0df13-fc05-40ed-a991-a9b64b95337e" alt="Star icon representing top-tier visibility and premium search placement on Zamzi Connect" width={40} height={40} className="mb-4" loading="lazy" />,
    title: "Top-Tier Visibility",
    description: "Premium members get priority placement. It's like a digital VIP lane that pushes your profile to the top for more leads and better opportunities.",
  },
];

export function WhyChooseZamziSection() {
  return (
    <section className="py-16 md:py-24" style={{ backgroundColor: '#f2f8f2' }}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-primary">
            Don't Just Compete, Dominate!
          </h2>
          <p className="text-lg max-w-3xl mx-auto text-muted-foreground">
            We don't just list your profile; we amplify it. Our smart technology is designed to turn your skills and services into real-world opportunities.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <Card key={index} className="text-center shadow-lg hover:shadow-xl hover:-translate-y-2 transition-all duration-300 border-b-0 border-x-0 border-t-4 border-[#77AB59]">
              <CardHeader className="flex flex-col items-center">
                {reason.icon}
                <CardTitle
                  className="text-xl font-semibold"
                  style={
                    reason.title === "GEO-Optimized Profiles" || reason.title === "AI-Powered SEO" || reason.title === "Top-Tier Visibility"
                      ? { color: "#FFB81C" }
                      : {}
                  }
                >
                  {reason.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">{reason.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
